import { Link } from 'react-router-dom'

interface ComicCardProps {
  id: number
  title: string
  author: string
  rating: number
  views: string
  status: string
  coverImage: string
  category: string
  tags?: string[]
}

const categoryNameMap: Record<string, string> = {
  love: '恋爱',
  fantasy: '奇幻',
  action: '动作',
  suspense: '悬疑',
  comedy: '搞笑',
  horror: '惊悚',
  daily: '日常',
  history: '古风',
}

export default function ComicCard({ id, title, author, rating, views, status, coverImage, category, tags }: ComicCardProps) {
  return (
    <Link to={`/comic/${id}`} className="group block">
      <div className="relative overflow-hidden rounded-lg aspect-[3/4]">
        <img
          src={coverImage}
          alt={title}
          title={`${title} - 韩漫画网`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
        <div className="absolute top-3 left-3">
          <span className={`px-2.5 py-1 rounded-full text-xs font-medium ${
            status === '已完结' ? 'bg-secondary-500 text-background-50' : 'bg-primary-500 text-background-50'
          }`}>
            {status}
          </span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 p-4 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
          <p className="text-background-50 text-sm font-medium mb-1">{categoryNameMap[category] || category}</p>
          <div className="flex items-center gap-2">
            <i className="ri-star-fill text-accent-500 text-xs"></i>
            <span className="text-background-50 text-xs">{rating}</span>
          </div>
        </div>
      </div>
      <div className="mt-3">
        <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">{title}</h3>
        <p className="text-xs text-foreground-600 mt-1">{author}</p>
        <div className="flex items-center gap-3 mt-1.5">
          <div className="flex items-center gap-1">
            <i className="ri-eye-line text-foreground-400 text-xs"></i>
            <span className="text-xs text-foreground-500">{views}</span>
          </div>
          <div className="flex items-center gap-1">
            <i className="ri-star-fill text-accent-500 text-xs"></i>
            <span className="text-xs text-foreground-500">{rating}</span>
          </div>
        </div>
        {tags && tags.length > 0 && (
          <div className="flex flex-wrap gap-1.5 mt-2">
            {tags.map((tag) => (
              <span key={tag} className="px-2 py-0.5 bg-secondary-100 text-secondary-700 text-[10px] rounded-full whitespace-nowrap">
                {tag}
              </span>
            ))}
          </div>
        )}
      </div>
    </Link>
  )
}